import { Event, Color, Property, createPropertyDescriptor, Material, defined } from 'cesium';
import img from './assets/colors1.png';

class PolylineTrailLinkMaterialProperty {
    constructor(option = {}) {
        this._definitionChanged = new Event();
        this._color = undefined;
        this._colorSubscription = undefined;
        this.color = option.color ? option.color : new Color(0.0, 0.0, 1.0, 0.5);
        this.duration = option.duration ? option.duration : 5000;
        this.image = option.image ? option.image : img;
        this._time = new Date().getTime();
        // 类型（会自动加载到 cesium 中）
        this.type = option.type ? option.type : 'PolylineTrailLink';

        // 着色器
        this.source = option.source
            ? option.source
            : `
    czm_material czm_getMaterial(czm_materialInput materialInput)
       {
        czm_material material = czm_getDefaultMaterial(materialInput);
        vec2 st = materialInput.st;
        vec4 colorImage = texture2D(image, vec2(fract(st.s - time), st.t));
        material.alpha = colorImage.a;
        material.diffuse = colorImage.rgb;
        return material;
      }
    `;

        this.addMaterial();
    }

    getType() {
        return 'PolylineTrailLink';
    }

    getValue(time, result) {
        let _result = result;
        if (!defined(_result)) {
            _result = {};
        }

        _result.color = Property.getValueOrClonedDefault(
            this._color,
            time,
            Color.WHITE,
            _result.color,
        );
        _result.image = this.trailImage;
        _result.time = ((new Date().getTime() - this._time) % this.duration) / this.duration;

        return _result;
    }

    equals(other) {
        return (
            this === other ||
            (other instanceof PolylineTrailLinkMaterialProperty &&
                Property.equals(this._color, other._color))
        );
    }

    addMaterial() {
        Material._materialCache.addMaterial(this.type, {
            fabric: {
                type: this.type,
                uniforms: {
                    color: new Color(0.0, 0.0, 1.0, 0.5),
                    image: this.image,
                    time: 100,
                },
                source: this.source,
            },

            translucent: () => {
                return true;
            },
        });

        // 注意 defineProperties 会报错，需要改为 Object
        Object.defineProperties(PolylineTrailLinkMaterialProperty.prototype, {
            isConstant: {
                get: () => {
                    return false;
                },
                configurable: true,
            },
            definitionChanged: {
                get: () => {
                    return this._definitionChanged;
                },
                configurable: true,
            },
            color: {
                value: createPropertyDescriptor('color'),
                configurable: true,
                writable: true,
            },
        });
    }
}

export default PolylineTrailLinkMaterialProperty;
